var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device_status_list_right"},[_c('div',[_vm._v(" 设备 ")]),_c('div',[_vm._v("状态")]),_c('div',{staticClass:"device-status-list"},_vm._l((_vm.myDeviceItems),function(item,idx){return _c('device-status-item2',{key:idx,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }